module.exports = __webpack_public_path__ + "media/images/locations/sm/chicago-4315f417cebb2e2947760632de71dafb.jpg";